import { AppState } from "./AppState.ts";

export const errorId = (fieldId: string) => `${fieldId}_error`;
export const warningId = (fieldId: string) => `${fieldId}_warning`;

export const hasWarningForField = (state: AppState, fieldId: string): boolean => {
  return state.calculation.warnings?.some((w) => w.belongsTo === fieldId);
};
